// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"buttons_primaryButton__YoGJQ","SecondaryButton":"buttons_SecondaryButton__u8mht","TertiaryButton":"buttons_TertiaryButton__mk9gQ"};